import { render, staticRenderFns } from "./invitationList.vue?vue&type=template&id=49dd367f&scoped=true&"
import script from "./invitationList.vue?vue&type=script&lang=js&"
export * from "./invitationList.vue?vue&type=script&lang=js&"
import style0 from "./invitationList.vue?vue&type=style&index=0&id=49dd367f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dd367f",
  null
  
)

export default component.exports